import { el, list, setChildren } from 'redom';

import './index.scss';

class SuggestionChip {

  constructor(suggestionChips) {

    this.suggestionChips = suggestionChips;
    this.chip = null;

    this.el = el('button.suggestion', {
      type: 'button',
      onmousedown: function onSuggestionMouseDown(event) {
        event.preventDefault();
      },
      onclick: function onSuggestionClick() {
        this.suggestionChips.onSelect(this.chip.value);
      }.bind(this)
    });

  }

  update(chip) {

    this.chip = chip;
    setChildren(this.el, [
      el('x-tooltip', {
        text: this.chip.text
      }, [el('div', {
        class: 'ellipsis'
      }, this.chip.text)])
    ]);

  }

}

class SuggestionChips {

  constructor(configuration) {

    this.onSelect = configuration.onSelect;

    this.list = list('.suggestion-chips-main', SuggestionChip, null, this);

    this.el = this.list.el;

  }

  update(chips) {

    this.list.update(chips);

  }

}

export default SuggestionChips;
